'use strict';

exports.__esModule = true;
exports['default'] = getError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _uvdomBootstrap = require('uvdom-bootstrap');

var _uvdomBootstrap2 = _interopRequireDefault(_uvdomBootstrap);

function getError(_ref) {
  var hasError = _ref.hasError;
  var error = _ref.error;

  if (hasError && error) {
    return _uvdomBootstrap2['default'].getErrorBlock({
      error: error,
      hasError: hasError
    });
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/tcomb-form/lib/templates/bootstrap/getError.js
// module id = 64
// module chunks = 0 1 2